const GoogleApiKey = 'AIzaSyDp29ckkGT-Uc-HU2eLsra9VHplHcyZecs'
const GoogleApiId = 'infinite-badge-393519'
const firebaseConfig = {
  apiKey: GoogleApiKey,
  authDomain: 'infinite-badge-393519.firebaseapp.com',
  projectId: GoogleApiId,
  storageBucket: 'infinite-badge-393519.appspot.com',
  messagingSenderId: '267380265681',
  appId: '1:267380265681:web:c425cec25c402d35e0abf0',
  measurementId: 'G-YWDJQ7TZHN',
}
const baseConfigs = {
  GoogleApiKey,
  GoogleApiId,
  firebaseConfig,
  Environment:
    window.configs?.mode || import.meta.env.VITE_APP_MODE || 'development',
}

export default function Configs() {
  const mode = window.configs?.mode || import.meta.env.VITE_APP_MODE

  switch (mode) {
    case 'development':
      return {
        ...baseConfigs,
        ApiUrl: 'https://api-dev.kiddom.co',
        AppUrl: 'https://app-dev.kiddom.co',
        ContentServiceUrl: 'https://content-dev.kiddom.co',
        TKatUrl: 'https://kat-dev.kiddom.co',
        SentryDSN:
          'https://9c2d5c6e5858bd1b0dd5fb2aa17f3ae3@o4508445939662848.ingest.us.sentry.io/4509017828425728',
      }
    case 'staging':
      return {
        ...baseConfigs,
        ApiUrl: 'https://api-staging.kiddom.co',
        AppUrl: 'https://app-staging.kiddom.co',
        ContentServiceUrl: 'https://content-staging.kiddom.co',
        TKatUrl: 'https://kat-staging.kiddom.co',
        SentryDSN:
          'https://154a955e8934ea5fa1cddb019c03f8b9@o4508445939662848.ingest.us.sentry.io/4509017828425728',
      }
    case 'staging-local':
      return {
        ...baseConfigs,
        ApiUrl: 'https://api-staging.kiddom.co',
        AppUrl: 'https://app-staging.kiddom.co',
        ContentServiceUrl: 'https://content-local.kiddom.co:9009',
        TKatUrl: 'https://kat-staging.kiddom.co',
        SentryDSN: '',
      }
    case 'production':
      return {
        ...baseConfigs,
        ApiUrl: 'https://api.kiddom.co',
        AppUrl: 'https://app.kiddom.co',
        ContentServiceUrl: 'https://content.kiddom.co',
        TKatUrl: 'https://kat.kiddom.co',
        SentryDSN:
          'https://bec72ec8927571dc9a85967d34f2dc93@o4508445939662848.ingest.us.sentry.io/4509017828425728',
      }
    case 'production-local':
      return {
        ...baseConfigs,
        ApiUrl: 'https://api.kiddom.co',
        AppUrl: 'https://app.kiddom.co',
        ContentServiceUrl: 'https://content-local.kiddom.co:9009',
        TKatUrl: 'https://app-local.kiddom.co:8080',
        SentryDSN: '',
      }
    case 'local':
      return {
        ...baseConfigs,
        ApiUrl: '',
        AppUrl: 'https://app-local.kiddom.co:8080',
        ContentServiceUrl: 'http://hermes-local.kiddom.co:9009',
        TKatUrl: 'https://admin-local.kiddom.co:8280',
        SentryDSN: '',
      }
    case 'testing':
      return {
        ...baseConfigs,
        ApiUrl: '',
        AppUrl: '',
        ContentServiceUrl: '',
        TKatUrl: '',
        SentryDSN: '',
      }
    default:
      return {
        ...baseConfigs,
        ApiUrl: 'https://app-local.kiddom.co:5443',
        AppUrl: 'https://app-local.kiddom.co:8443',
        ContentServiceUrl: 'https://content-local.kiddom.co:9009',
        TKatUrl: 'https://app-local.kiddom.co:8080',
        SentryDSN:
          'https://9c2d5c6e5858bd1b0dd5fb2aa17f3ae3@o4508445939662848.ingest.us.sentry.io/4509017828425728',
      }
  }
}
